import cx from 'classnames';
import * as React from 'react';
import { ServiceSchedule } from '../shared-types';
import { ComboBookingForm, ComboDetails } from './combo-booking-form';
import { useLocalize } from './localize-context';
import { PackagesBookingForm, PackageDetails } from './packages-booking-form';
import { SelectField } from './select-field';

type PackagesAndComboBookingFormProps = {
  packages: PackageDetails[];
  schedules: ServiceSchedule[];
  combo: ComboDetails;
};

export const PackagesAndComboBookingForm = (
  props: PackagesAndComboBookingFormProps
) => {
  const l = useLocalize();
  const [offerType, setOfferType] = React.useState<OfferType>('package');

  return (
    <div className="max-w-sm mx-auto sm:max-w-none">
      <SelectField
        value={offerType}
        onChangeValue={val => setOfferType(val as OfferType)}
        options={[
          {
            label: l('Packages'),
            value: 'package',
          },
          {
            label: l('Combo'),
            value: 'combo',
          },
        ]}
        required
        wrapperClassName="w-36 mb-2"
      />
      <div className={cx(offerType === 'package' && 'hidden')}>
        <ComboBookingForm combo={props.combo} />
      </div>
      <div className={cx(offerType === 'combo' && 'hidden')}>
        <PackagesBookingForm
          packages={props.packages}
          schedules={props.schedules}
        />
      </div>
    </div>
  );
};

type OfferType = 'package' | 'combo';
